import React from 'react';
import getDisplayableSaleTypes from '../selectors/getDisplayableSaleTypes';
import Modal from '../components/Modal';
import { useAppSelector } from '../app/hooks';
import { OrderingSelectors, determineLocationSessions } from 'polygon-ordering';
import SaleTypeListItem from '../components/SaleTypeListItem';
import { DELIVERY_SALE_TYPES } from '../libs/polygon-ordering/src/constants';

export const ORDER_TYPE_MODAL_ID = 'ORDER_TYPE_MODAL_ID';

const { getLocation, getOrderingWindowPadding, getSaleType, getSubDisplayableSaleTypes } =
  OrderingSelectors;

const OrderTypeModal = () => {
  const location = useAppSelector(getLocation);
  const locationId = location ? location.id : null;
  const orderingWindowPadding = useAppSelector(getOrderingWindowPadding);
  const saleType = useAppSelector(getSaleType);

  const enhancedLocation = {
    ...location,
    ...determineLocationSessions(location, orderingWindowPadding, saleType),
  };
  const modalParams = useAppSelector(state => state.modalParams);
  const saleTypeModal = modalParams?.saleType;

  const displayableSaleTypes = useAppSelector(getDisplayableSaleTypes);
  const displayableSubSaleTypes = useAppSelector(getSubDisplayableSaleTypes(saleTypeModal));

  const unfilteredSaletypesByLocation = saleTypeModal
    ? displayableSubSaleTypes
    : displayableSaleTypes;

  // Isnt this always true???
  const filterSaleTypesByLocation = Boolean(location && enhancedLocation);

  // Sale types that are currently available for this location
  const saleTypesToDisplay = filterSaleTypesByLocation
    ? unfilteredSaletypesByLocation?.filter(
        option =>
          enhancedLocation?.takingOrders?.includes(option) || DELIVERY_SALE_TYPES.includes(option),
      ) || []
    : unfilteredSaletypesByLocation;

  return (
    <Modal desktopMaxWidth={400} desktopMinWidth={350}>
      <div style={{ paddingTop: 20, gap: 15, display: 'flex', flexDirection: 'column' }}>
        {saleTypesToDisplay.map(displayableSaleType => (
          <SaleTypeListItem
            key={displayableSaleType}
            saleType={displayableSaleType}
            locationId={locationId}
          />
        ))}
      </div>
    </Modal>
  );
};

/* const styles: Styles = {}; */

export default OrderTypeModal;
